import styled from "styled-components";

export const TextArea = styled.textarea`
  min-height: 130px;
  max-height: 220px;
  resize: vertical;

  ::-webkit-scrollbar-track {
      background-color: transparent;
  }
  ::-webkit-scrollbar {
      width: 6px;
      background: #F4F4F4;
      border-radius: 5px;
  }
  ::-webkit-scrollbar-thumb {
      background: #f97316;
      border-radius: 5px;
  }
`
